import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';

export interface Props {}

const StudioProductsCatalogCardC: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId="a3d0b02e-5b2f-4587-a4a3-f606e05cf067"
  />
);
StudioProductsCatalogCardC.displayName = 'StudioProductsCatalogCardC';

export default StudioProductsCatalogCardC;
